import { render, staticRenderFns } from "./borrowing-summary-form.component.vue?vue&type=template&id=38c2bb77&scoped=true"
import script from "./borrowing-summary-form.component.vue?vue&type=script&lang=js"
export * from "./borrowing-summary-form.component.vue?vue&type=script&lang=js"
import style0 from "./borrowing-summary-form.component.vue?vue&type=style&index=0&id=38c2bb77&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c2bb77",
  null
  
)

export default component.exports